import { makeStyles } from "@material-ui/core";

export const StepsToCompleteStyles = makeStyles((theme) => ({
    dragIcon: {
        cursor: 'move',
        lineHeight: '1rem',
        '& path': {
            fill: '#ddd'
        },
        '&:hover': {
            '& path': {
                fill: theme.palette.secondary.dark
            },
        }
    },
    optionsContainer: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        padding: '0.5rem 0 0'
    },
    saveRow: {
        marginTop: 'auto',
        paddingTop: '1rem',
        display: 'flex',
        alignItems: 'center'
    },
    multiValueOpt: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        height: '3rem',
        paddingTop: '0.7rem'
    },
    stepRow: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        flexWrap: 'nowrap',
        paddingLeft: '9px'
    },
    addStepBtn: {
        width: '100%',
        justifyContent: 'flex-start',
        paddingLeft: '0.5rem',
        borderBottom: `1px solid ${theme.palette.divider}`,
        borderRadius: 0,
        height: '3rem',
        color: theme.palette.text.secondary,
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
            color: theme.palette.primary.main,
        }
    },
    stepInput: {
        flex: 1,
        minWidth: 0,
        padding: '2px 0'
    },
    completedStep: {
        textDecoration: 'line-through'
    },
    deleteIcon: {
        width: '0.7em'
    },
    saveBtn: {
        minWidth: '110px'
    },
    checkbox: {
        margin: '0 0.5em',
    },
    dragContainer: {
    },
    overwriteConfig: {
        marginLeft: '1rem',
        '& .MuiFormControlLabel-label': {
            fontSize: 14
        }
    }
}));